import { Check } from "lucide-react";

// Mehrstufiger Fortschrittsbalken (Stepper) im Doctolib/Salesforce-Stil.
// steps: [{ key, label }], current: index, completed: Set<index>, onStepClick?(index)
export function FormStepper({ steps, current, maxReached = 0, onStepClick }) {
  return (
    <nav aria-label="Fortschritt" data-testid="form-stepper">
      <ol className="flex items-center w-full">
        {steps.map((step, idx) => {
          const isActive = idx === current;
          const isDone = idx < current || idx <= maxReached - 1 ? idx < current : false;
          const reached = idx <= maxReached;
          const clickable = reached && typeof onStepClick === "function";
          return (
            <li key={step.key} className={`flex items-center ${idx < steps.length - 1 ? "flex-1" : ""}`}>
              <button
                type="button"
                disabled={!clickable}
                onClick={() => clickable && onStepClick(idx)}
                className={`group flex items-center gap-2.5 ${clickable ? "cursor-pointer" : "cursor-default"}`}
                data-testid={`stepper-step-${idx}`}
              >
                <span
                  className={`flex items-center justify-center w-8 h-8 rounded-full text-sm font-semibold shrink-0 transition-colors
                    ${isActive
                      ? "bg-[#1A3A5C] text-white ring-4 ring-[#1A3A5C]/15"
                      : idx < current
                      ? "bg-[#E8700A] text-white"
                      : "bg-slate-200 text-slate-500 dark:bg-slate-700 dark:text-slate-300"}`}
                >
                  {idx < current ? <Check className="w-4 h-4" /> : idx + 1}
                </span>
                <span
                  className={`hidden sm:block text-sm font-medium transition-colors whitespace-nowrap
                    ${isActive ? "text-[#1A3A5C] dark:text-blue-300" : idx < current ? "text-[#E8700A]" : "text-slate-400"}`}
                >
                  {step.label}
                </span>
              </button>
              {idx < steps.length - 1 && (
                <span
                  className={`flex-1 h-0.5 mx-2 sm:mx-3 rounded transition-colors ${idx < current ? "bg-[#E8700A]" : "bg-slate-200 dark:bg-slate-700"}`}
                />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
